@if (visible()) {
  <a class="franja" href="/11-11/">
    <img class="logo" src="/assets/promo-11-11.svg" width="86" height="46" alt="Promo del 11.11" decoding="async">
    <b>Mega oferta en AliExpress</b>
    <span class="cuenta">
      {{ cuenta().fase === 'antes' ? 'Empieza en' : 'Acaba en' }} {{ cuenta().dias }}d {{ cuenta().horas }}h {{ cuenta().minutos }}m
    </span>
    <span class="boton">Ver ofertas</span>
  </a>
}
